import { classNames } from '@ember-decorators/component';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './empty-state.module.scss';

@classic
@classNames('empty-state', styles.component)
export default class SharedEmptyState extends Component {}
